<template>
  <div class="map-reserve">
    <div class="mapHeader">
      <div style="height: 0.2rem;"></div>
      <div class="input" @click.stop="startSearch">
        <div class="search-icon"></div>
        <input class="search-input" type="text" ref="searchInput" v-model="centerName" readonly
          placeholder="请输入政务服务地点" />
      </div>
      <div style="height: 0.2rem;"></div>

      <!--筛选栏-->
      <div class="filter-bar">
        <div class="filter-item" :class="{ active: showDistanceFilter }" @click="toggleFilter('distance')">
          <span>{{ distanceLabel }}</span>
          <van-icon name="arrow-down" size="12" />
        </div>
        <div class="filter-item" :class="{ active: showAreaFilter }" @click="toggleFilter('area')">
          <span>{{ areaLabel }}</span>
          <van-icon name="arrow-down" size="12" />
        </div>
        <div class="filter-item" :class="{ active: showTypeFilter }" @click="toggleFilter('type')">
          <span>{{ typeLabel }}</span>
          <van-icon name="arrow-down" size="12" />
        </div>
        <div class="filter-reset" @click="resetFilter">重置</div>
      </div>

      <!--筛选下拉面板-->
      <div class="filter-dropdown" v-if="showDistanceFilter">
        <div class="filter-option" v-for="item in distanceOptions" :key="item.value"
          :class="{ selected: filterDistance === item.value }" @click="selectDistance(item)">
          {{ item.label }}
        </div>
      </div>
      <div class="filter-dropdown" v-if="showAreaFilter">
        <template v-if="areaOptions.length > 0">
          <div class="filter-option" v-for="item in areaOptions" :key="item.value"
            :class="{ selected: filterArea === item.value }" @click="selectArea(item)">
            {{ item.label }}
          </div>
        </template>
        <div class="filter-empty" v-else>暂无区域数据</div>
      </div>
      <div class="filter-dropdown" v-if="showTypeFilter">
        <div class="filter-option" v-for="item in typeOptions" :key="item.value"
          :class="{ selected: filterType === item.value }" @click="selectType(item)">
          {{ item.label }}
        </div>
      </div>
      <div style="height: 0.2rem;"></div>
    </div>
    <div class="mapBox">
      <div class="map" id="map" ref="map"></div>
      <!-- 地图图例 -->
      <div class="map-legend">
        <div class="legend-item"><span class="legend-dot" style="background:#E53935;"></span>市级</div>
        <div class="legend-item"><span class="legend-dot" style="background:#1E88E5;"></span>区级</div>
        <div class="legend-item"><span class="legend-dot" style="background:#43A047;"></span>街道</div>
        <div class="legend-item"><span class="legend-dot" style="background:#FB8C00;"></span>社区</div>
      </div>
      <div class="loading" v-if="showLoading">
        <van-loading text-color="#0094ff" />
      </div>
      <div class="content">
        <!-- <div class="fkImg" @click="fkReply()"><img src="../assets/imgs/fk.png"></div> -->
        <div class="pointInfo" @click="goSiteDetail">
          <div class="pointInfo-top">
            <div class="info">
              <div class="name">
                <span>{{ info.name }}</span>
                <span class="view-all" @click.stop="showSiteList = true">全部网点 ></span>
              </div>
              <div class="detail address">
                <img src="../assets/imgs/address.png">
                <span v-text="info.address"></span>
              </div>
              <div class="detail time">
                <img src="../assets/imgs/time.png">
                <span v-text="info.time"></span>
              </div>
              <div class="detail road">
                <img src="../assets/imgs/road.png">
                <span v-html="info.road"></span>
              </div>
            </div>
            <div class="navigation" @click="goToSiteDetail">
              <img src="../assets/imgs/navigation.png">
              <span>去办事</span>
              <label>距您{{ subLiangWei(info.distance) }}km</label>
            </div>
          </div>
          <div class="pointInfo-bottom">
            <div class="phone" @click.stop="tellPhone">
              <img src="../assets/imgs/phone.png">
              <span>咨询电话</span>
            </div>
            <!-- <div class="phone" @click.stop="guideList">
              <img src="../assets/imgs/guide.png">
              <span>办事指南</span>
            </div> -->
            <div class="subscribe" @click.stop="subscribeProject">
              <img src="../assets/imgs/subscribe.png">
              <span>快速预约</span>
            </div>
          </div>
        </div>

        <div class="business" @click.stop>
          <div class="business-card refer" @click.stop="goItemCategory()">
            <div class="card-title">事项分类</div>
            <div class="card-icon query-icon">
              <van-icon name="apps-o" size="32" color="#1989fa" />
            </div>
            <div class="card-btn query-btn">去查看 >></div>
          </div>
          <div class="business-card window" @click.stop="showItemRecommend = true">
            <div class="card-title">事项推荐</div>
            <div class="card-icon recommend-icon">
              <van-icon name="todo-list-o" size="32" color="#ff6b35" />
            </div>
            <div class="card-btn recommend-btn">去查看 >></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索组件 -->
    <SiteSearch v-model="showSearchLayer" :siteList="allSiteList" @select="onSiteSelect" />
    
    <!-- 事项推荐组件 -->
    <ItemRecommend v-model="showItemRecommend" :siteId="info.id" :siteName="info.name" />
    
    <!-- 站点列表组件 -->
    <SiteList v-model="showSiteList" :siteList="allSiteList" @select="onSiteListSelect" />

    <!--底部导航（与首页一致）-->
    <div class="bottom-nav">
      <div class="nav-item" @click="routerHome()">
        <van-icon name="wap-home" size="22" />
        <span>首页</span>
      </div>
      <div class="nav-item active">
        <van-icon name="location-o" size="22" />
        <span>地图</span>
      </div>
      <div class="nav-item" @click="routerUser()">
        <van-icon name="user-o" size="22" />
        <span>我的</span>
      </div>
    </div>
  </div>
</template>


<script>

import { Dialog, Icon, Toast, Empty, Loading, Popup, ActionSheet } from 'vant';
import mapMaker from '@/assets/imgs/mapMarker.png';
import ItemRecommend from '@/components/ItemRecommend.vue';
import SiteSearch from '@/components/SiteSearch.vue';
import SiteList from '@/components/SiteList.vue';
import { getAllSiteList, getAreaList as getAreaListApi, getNearbyList, getDefaultArea } from '@/api/apis';
import {
  siteDictList as mockSiteDictList,
  siteList as mockSiteList
} from '@/mock/siteData';

// 不同级别站点的标记颜色配置
const MARKER_COLORS = {
  '1': { bg: '#E53935', label: '市级', textColor: '#E53935' },   // 红色 - 市级
  '2': { bg: '#1E88E5', label: '区级', textColor: '#1E88E5' },   // 蓝色 - 区级
  '3': { bg: '#43A047', label: '街道', textColor: '#43A047' },   // 绿色 - 街道
  '4': { bg: '#FB8C00', label: '社区', textColor: '#FB8C00' }    // 橙色 - 村/社区
};

export default {
  name: 'MapService',
  data() {
    return {
      centerName: '',
      tempCenterName: '',
      markerList: [],
      mapObj: null,
      info: {
        id: '',
        name: '',
        address: '',
        time: '',
        road: '',
        phone: '',
        lng: '',
        lat: '',
        centerguid: '',
        distance: '',
        areaLevel: ''
      },
      siteList: [], //地图站点列表
      allSiteList: [], //全部站点数据（用于筛选）
      // 用户定位
      userLocation: {
        lng: '',
        lat: ''
      },
      showClear: false,
      currentTab: 5,
      showSearchLayer: false,
      searchResult: false,
      siteDictList: [],
      // 筛选相关
      showDistanceFilter: false,
      showAreaFilter: false,
      showTypeFilter: false,
      filterDistance: '',
      filterArea: '',
      filterType: '',
      distanceOptions: [
        { label: '全部距离', value: '' },
        { label: '1km以内', value: '1' },
        { label: '3km以内', value: '3' },
        { label: '5km以内', value: '5' },
        { label: '10km以内', value: '10' }
      ],
      areaOptions: [
        { label: '全部区域', value: '' }
      ],
      typeOptions: [
        { label: '全部类型', value: '' },
        { label: '市级', value: '1' },
        { label: '区级', value: '2' },
        { label: '街道', value: '3' },
        { label: '社区', value: '4' }
      ],

      showLoading: false,
      defLag: '111.32454668728992',
      defLat: '30.6984226458409',
      showItemRecommend: false,  // 事项推荐弹窗
      showSiteList: false  // 站点列表弹窗
    }
  },
  components: {
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    ItemRecommend,
    SiteSearch,
    SiteList
  },
  computed: {
    distanceLabel() {
      const item = this.distanceOptions.find(o => o.value === this.filterDistance);
      return item ? item.label : '按距离';
    },
    areaLabel() {
      const item = this.areaOptions.find(o => o.value === this.filterArea);
      return item ? item.label : '按区域';
    },
    typeLabel() {
      const item = this.typeOptions.find(o => o.value === this.filterType);
      return item ? item.label : '按类型';
    }
  },
  created() {
    //获取用户定位，然后获取站点列表
    this.getUserLocation();
    //字典列表
    this.getSiteDict();
    //获取区域列表
    this.getAreaList();
    //获取默认区划
    this.fetchDefaultArea();
    
    // 检查是否从首页搜索跳转过来
    if (this.$route.query.openSearch === 'true') {
      this.$nextTick(() => {
        this.showSearchLayer = true;
      });
    }
  },
  methods: {
    //初始化地图
    async initMap() {
      this.markerList = [];
      if (this.siteList.length > 0) {
        for (let item of this.siteList) {
          // 高德地图使用GCJ-02坐标系，无需转换
          this.markerList.push(item);
        }
      }

      // 只在首次时创建地图实例，之后复用
      if (!this.mapObj) {
        this.mapObj = new AMap.Map("map", {
          zoom: 13,
          scrollWheel: true,
          showIndoorMap: false  // 隐藏室内地图
        });

        // 隐藏高德地图logo和反馈按钮
        this.mapObj.on('complete', () => {
          this.hideMapControls();
        });

        // 延迟再次隐藏，确保动态加载的元素也被隐藏
        setTimeout(() => {
          this.hideMapControls();
        }, 1000);
      } else {
        // 清除已有标记点
        this.mapObj.clearMap();
      }

      if (this.markerList.length == 0) {
        this.mapObj.setCenter([this.defLag, this.defLat]);
        return false;
      } else {
        this.mapObj.setCenter([this.siteList[0].lng, this.siteList[0].lat]);
      }

      this.info.id = this.markerList[0].id;
      this.info.name = this.markerList[0].siteName;
      this.info.centerguid = this.markerList[0].centerguid;
      this.info.address = this.markerList[0].address;
      this.info.time = this.markerList[0].time;
      this.info.road = this.markerList[0].traffic;
      this.info.phone = this.markerList[0].phone;
      this.info.lng = this.markerList[0].lng;
      this.info.lat = this.markerList[0].lat;
      this.info.distance = this.markerList[0].distance;
      this.info.areaLevel = this.markerList[0].areaLevel;

      for (let item of this.markerList) {
        this.tempCenterName = item.siteName;

        // 创建自定义标记，传入areaLevel参数
        var markerContent = this.createDOM(item.areaLevel);
        var marker = new AMap.Marker({
          position: [item.lng, item.lat],
          content: markerContent,
          offset: new AMap.Pixel(-18, -41),
          extData: {
            id: item.id,
            name: item.siteName,
            centerguid: item.centerguid,
            address: item.address,
            time: item.time,
            road: item.traffic,
            lng: item.lng,
            lat: item.lat,
            phone: item.phone,
            distance: item.distance,
            areaLevel: item.areaLevel
          }
        });

        this.mapObj.add(marker);

        var _this = this;
        marker.on('click', function (e) {
          var data = e.target.getExtData();
          _this.mapObj.setZoomAndCenter(15, [data.lng, data.lat]);
          _this.info.id = data.id;
          _this.info.name = data.name;
          _this.info.centerguid = data.centerguid;
          _this.info.address = data.address;
          _this.info.time = data.time;
          _this.info.road = data.road;
          _this.info.phone = data.phone;
          _this.info.lng = data.lng;
          _this.info.lat = data.lat;
          _this.info.distance = data.distance;
          _this.info.areaLevel = data.areaLevel;
        });
      }
    },
    createDOM(areaLevel) {
      // 获取当前级别的颜色配置
      const colorConfig = MARKER_COLORS[areaLevel] || MARKER_COLORS['1'];

      // 创建容器div
      const container = document.createElement('div');
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
      container.style.alignItems = 'center';

      // 创建标记图标（使用SVG绘制不同颜色的标记）
      const markerSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      markerSvg.setAttribute('width', '37');
      markerSvg.setAttribute('height', '41');
      markerSvg.setAttribute('viewBox', '0 0 37 41');
      markerSvg.innerHTML = `
        <path d="M18.5 0C8.3 0 0 8.3 0 18.5C0 32.4 18.5 41 18.5 41S37 32.4 37 18.5C37 8.3 28.7 0 18.5 0Z" fill="${colorConfig.bg}"/>
        <circle cx="18.5" cy="16" r="8" fill="white"/>
      `;
      container.appendChild(markerSvg);

      // 创建站点名称标签
      const label = document.createElement('p');
      label.style.color = colorConfig.textColor;
      label.style.fontSize = '12px';
      label.style.fontWeight = 'bolder';
      label.style.width = 'max-content';
      label.style.margin = '2px 0 0 0';
      label.style.textShadow = '0 0 2px white, 0 0 2px white';
      label.textContent = this.tempCenterName;
      container.appendChild(label);

      return container;
    },
    // 隐藏地图控件（logo、版权、反馈按钮）
    hideMapControls() {
      const hideElement = (el) => {
        if (el) {
          el.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;';
        }
      };

      // 隐藏logo和版权
      hideElement(document.querySelector('.amap-logo'));
      hideElement(document.querySelector('.amap-copyright'));

      // 隐藏反馈按钮和其他控件
      const mapContainer = document.getElementById('map');
      if (mapContainer) {
        // 查找包含特定文字的元素
        const keywords = ['反馈', '高德', 'amap', 'Amap', '©'];
        mapContainer.querySelectorAll('div, a, span, img').forEach(el => {
          const text = el.textContent || '';
          const href = el.getAttribute('href') || '';
          const src = el.getAttribute('src') || '';

          if (keywords.some(k => text.includes(k) || href.includes(k) || src.includes(k))) {
            hideElement(el);
            if (el.parentElement && el.parentElement.children.length <= 2) {
              hideElement(el.parentElement);
            }
          }
        });
      }
    },
    // 获取用户定位
    getUserLocation() {

      this.getSiteList();
      return false;
      this.showLoading = true;

      // 使用高德地图定位
      if (typeof AMap !== 'undefined' && AMap.Geolocation) {
        AMap.plugin('AMap.Geolocation', () => {
          const geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
          });

          geolocation.getCurrentPosition((status, result) => {
            if (status === 'complete' && result.position) {
              this.userLocation.lng = result.position.lng;
              this.userLocation.lat = result.position.lat;
              console.log('定位成功:', this.userLocation);
              this.getSiteList();
            } else {
              console.log('定位失败，使用默认位置');
              this.useDefaultLocation();
            }
          });
        });
      } else {
        // 降级使用浏览器原生定位
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.userLocation.lng = position.coords.longitude;
              this.userLocation.lat = position.coords.latitude;
              console.log('浏览器定位成功:', this.userLocation);
              this.getSiteList();
            },
            () => {
              console.log('浏览器定位失败，使用默认位置');
              this.useDefaultLocation();
            },
            { enableHighAccuracy: true, timeout: 10000 }
          );
        } else {
          this.useDefaultLocation();
        }
      }
    },
    // 使用默认位置（宜昌市中心）
    useDefaultLocation() {
      this.userLocation.lng = this.defLag;
      this.userLocation.lat = this.defLat;
      this.getSiteList();
    },
    // 计算两点之间的距离（单位：km）
    calculateDistance(lng1, lat1, lng2, lat2) {
      const rad = (d) => d * Math.PI / 180.0;
      const R = 6371; // 地球半径，单位km

      const dLat = rad(lat2 - lat1);
      const dLng = rad(lng2 - lng1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return (R * c).toFixed(2);
    },
    // 高德地图使用GCJ-02坐标系，此方法保留但不再需要坐标转换
    // 如果原始数据是WGS84坐标，可使用高德的坐标转换服务
    //电话号码
    tellPhone() {
      let phoneNumber = this.info.phone.replace('-', '');
      if (phoneNumber) {
        window.location.href = 'tel:' + phoneNumber;
      } else {
        Dialog.alert({
          message: '未查询到电话号码',
          theme: 'round-button',
        });
      }

    },
    //事项分类
    goItemCategory() {
      this.$router.push({
        path: '/item-category',
        query: { siteId: this.info.id, siteName: this.info.name }
      });
    },

    //导航
    navigation() {
      let name = this.info.name;
      let lng = this.info.lng;
      let lat = this.info.lat;
      window.location.href = 'http://uri.amap.com/navigation?from=,,起点&to=' + lng + ',' + lat + ',' + name + '&mode=bus&callnative=0';
    },
    //去办事 - 跳转到网点详情页
    goToSiteDetail() {
      if (this.info && this.info.id) {
        this.$router.push({
          name: 'MapDetail',
          query: {
            id: this.info.id,
            distance: this.subLiangWei(this.info.distance)
          }
        });
      }
    },
    //跳转预约
    subscribeProject() {
      this.$router.push({
        name: 'subscribeProject', query: {
          centerName: this.info.name,
          areaCode: window.config?.areaCode || '',
          from: '/map'
        }
      });
    },
    //跳转网点详情
    goSiteDetail() {
      this.$router.push({
        name: 'SiteDetail',
        query: {
          id: this.info.id,
          distance: this.info.distance
        }
      });
    },
    //小数点截取两位
    subLiangWei(num) {
      if (num === undefined || num === null || num === '') {
        return '0';
      }
      const n = Number(num);
      return isNaN(n) ? '0' : n.toFixed(2);
    },
    //获取站点列表
    async getSiteList() {
      this.showLoading = true;
      this.siteList = [];

      try {
        // 调用真实接口获取站点数据
        const res = await getAllSiteList({
          areaCode: window.config.areaCode
        });
        
        if (res.data && res.data.success) {
          const siteData = res.data.obj || res.data.data || [];
          
          // 映射接口字段到页面使用的字段
          const mappedSites = siteData.map(site => ({
            id: site.id || site.siteCode,
            siteName: site.siteName,
            address: site.address,
            lng: site.lng,
            lat: site.lat,
            time: site.time || '',
            phone: site.phone || '',
            areaLevel: String(site.areaLevel || '4'),
            traffic: site.traffic || '',
            areaName: site.areaName || '',
            siteDesc: site.siteDesc || '',
            areaCode: site.areaCode || '',
            centerguid: site.centerguid || ''
          }));
          
          // 计算每个站点到用户的距离
          const sitesWithDistance = mappedSites.map(site => {
            const distance = this.calculateDistance(
              this.userLocation.lng || this.defLag,
              this.userLocation.lat || this.defLat,
              site.lng,
              site.lat
            );
            return { ...site, distance };
          });

          // 按距离排序（最近的在前面）
          sitesWithDistance.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));

          this.allSiteList = sitesWithDistance;
          this.siteList = [...sitesWithDistance];

          if (this.siteList.length > 0) {
            this.initMap();
            Toast.success(`已为您匹配最近的网点：${this.siteList[0].siteName}`);
          } else {
            if (this.mapObj) {
              this.mapObj.clearMap();
            }
            this.initMap();
            Toast.fail('暂无相关站点');
          }
        } else {
          // 接口返回错误，使用模拟数据
          this.useMockData();
        }
      } catch (error) {
        console.error('获取站点列表失败:', error);
        // 接口调用失败，使用模拟数据
        this.useMockData();
      } finally {
        this.showLoading = false;
      }
    },
    
    // 使用模拟数据（接口失败时的降级方案）
    useMockData() {
      const sitesWithDistance = mockSiteList.map(site => {
        const distance = this.calculateDistance(
          this.userLocation.lng || this.defLag,
          this.userLocation.lat || this.defLat,
          site.lng,
          site.lat
        );
        return { ...site, distance };
      });

      sitesWithDistance.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));

      this.allSiteList = sitesWithDistance;
      this.siteList = [...sitesWithDistance];

      if (this.siteList.length > 0) {
        this.initMap();
        Toast.success(`已为您匹配最近的网点：${this.siteList[0].siteName}`);
      } else {
        this.initMap();
        Toast.fail('暂无相关站点');
      }
    },
    //弹出搜索
    startSearch() {
      this.showSearchLayer = true;
    },
    //获取站点字典
    getSiteDict() {
      // 使用模拟数据
      this.siteDictList = mockSiteDictList;

      // ========== 原接口调用代码（保留备用）==========
      // let _this = this;
      // $.ajax({
      //   url: window.config.testApi + "/system/dict/data/list",
      //   type: "GET",
      //   data: { dictType: 'area_levels' },
      //   async: false,
      //   success: function (res) {
      //     if (res.code == 200) {
      //       _this.siteDictList = res.rows;
      //     }
      //   }
      // });
      // ========== 原接口调用代码结束 ==========
    },
    // 获取默认区划
    async fetchDefaultArea() {
      try {
        const res = await getDefaultArea();
        console.log('默认区划数据:', res.data);
      } catch (error) {
        console.error('获取默认区划失败:', error);
      }
    },
    // 获取区域列表
    async getAreaList() {
      try {
        const res = await getAreaListApi({ areaCode: window.config.areaCode });
        if (res.data && res.data.success && res.data.obj) {
          const data = res.data.obj;
          const areaList = data.list || [];
          if (areaList.length > 0) {
            // 构建区域选项，第一项为"全部区域"
            this.areaOptions = [{ label: '全部区域', value: '' }];
            // 添加接口返回的区域
            areaList.forEach(area => {
              this.areaOptions.push({
                label: area.areaName,
                value: area.areaCode,
                areaId: area.areaId,
                areaLevel: area.areaLevel
              });
            });
          } else {
            // 接口返回空数据，显示空白
            this.areaOptions = [];
          }
        } else {
          // 接口返回失败，显示空白
          this.areaOptions = [];
        }
      } catch (error) {
        console.error('获取区域列表失败:', error);
        this.areaOptions = [];
      }
    },
    // 站点列表选中站点
    onSiteListSelect(site) {
      this.onSiteSelect(site);
    },
    // 搜索组件选中站点
    onSiteSelect(site) {
      this.centerName = site.siteName;
      this.info.id = site.id;
      this.info.name = site.siteName;
      this.info.centerguid = site.centerguid;
      this.info.address = site.address;
      this.info.time = site.time;
      this.info.road = site.traffic;
      this.info.phone = site.phone;
      this.info.lng = site.lng;
      this.info.lat = site.lat;
      this.info.distance = site.distance;
      this.info.areaLevel = site.areaLevel;
      if (this.mapObj) {
        this.mapObj.setZoomAndCenter(15, [site.lng, site.lat]);
      }
    },
    changeTab(val, item) {
      if (val == 5) {
        this.currentTab = val;
        this.getSiteList();
      } else {
        this.currentTab = val + 1;
        this.getSiteList(item.dictValue);  //根据层级获取值
      }
    },
    // 切换筛选下拉
    toggleFilter(type) {
      if (type === 'distance') {
        this.showDistanceFilter = !this.showDistanceFilter;
        this.showAreaFilter = false;
        this.showTypeFilter = false;
      } else if (type === 'area') {
        this.showAreaFilter = !this.showAreaFilter;
        this.showDistanceFilter = false;
        this.showTypeFilter = false;
      } else if (type === 'type') {
        this.showTypeFilter = !this.showTypeFilter;
        this.showDistanceFilter = false;
        this.showAreaFilter = false;
      }
    },
    // 选择距离筛选
    selectDistance(item) {
      this.filterDistance = item.value;
      this.showDistanceFilter = false;
      this.applyFilter();
    },
    // 选择区域筛选
    selectArea(item) {
      this.filterArea = item.value;
      this.showAreaFilter = false;
      this.applyFilter();
    },
    // 选择类型筛选
    selectType(item) {
      this.filterType = item.value;
      this.showTypeFilter = false;
      this.applyFilter();
    },
    // 重置筛选
    resetFilter() {
      this.filterDistance = '';
      this.filterArea = '';
      this.filterType = '';
      this.showDistanceFilter = false;
      this.showAreaFilter = false;
      this.showTypeFilter = false;
      this.applyFilter();
    },
    // 应用筛选
    async applyFilter() {
      this.showLoading = true;
      
      // 如果选择了距离筛选，调用附近网点接口
      if (this.filterDistance) {
        await this.fetchNearbyList();
      } else if (this.filterType || this.filterArea) {
        // 选择了类型或区域筛选，调用接口获取数据
        await this.fetchSiteListByFilter();
      } else {
        // 没有筛选条件，显示全部数据
        this.siteList = [...this.allSiteList];
        this.updateMap();
      }
    },
    // 根据筛选条件调用接口获取站点列表
    async fetchSiteListByFilter() {
      try {
        const params = {
          areaCode: window.config.areaCode
        };
        
        // 网点类型筛选
        if (this.filterType) {
          params.siteType = this.filterType;
        }
        
        const res = await getAllSiteList(params);
        if (res.data && res.data.success) {
          const siteData = res.data.obj || [];
          
          // 映射接口字段
          let mappedSites = siteData.map(site => ({
            id: site.id || site.siteCode,
            siteName: site.siteName,
            address: site.address,
            lng: site.lng,
            lat: site.lat,
            time: site.time || '',
            phone: site.phone || '',
            areaLevel: String(site.siteType || site.areaLevel || '4'),
            traffic: site.traffic || '',
            areaCode: site.areaCode || '',
            centerguid: site.centerguid || '',
            distance: this.calculateDistance(
              this.userLocation.lng || this.defLag,
              this.userLocation.lat || this.defLat,
              site.lng,
              site.lat
            )
          }));
          
          // 按区域筛选（本地过滤）
          if (this.filterArea) {
            mappedSites = mappedSites.filter(site => {
              if (site.areaCode) {
                return site.areaCode.startsWith(this.filterArea);
              }
              const areaItem = this.areaOptions.find(o => o.value === this.filterArea);
              return areaItem && site.address && site.address.includes(areaItem.label);
            });
          }
          
          // 按距离排序
          mappedSites.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
          
          this.siteList = mappedSites;
        } else {
          this.siteList = [];
        }
      } catch (error) {
        console.error('获取站点列表失败:', error);
        this.siteList = [];
      }
      
      this.updateMap();
    },
    // 调用附近网点接口
    async fetchNearbyList() {
      try {
        // 使用默认网点（第一个网点）的经纬度作为基准
        const baseLng = this.allSiteList.length > 0 ? this.allSiteList[0].lng : this.defLag;
        const baseLat = this.allSiteList.length > 0 ? this.allSiteList[0].lat : this.defLat;
        
        const params = {
          longitude: baseLng,
          latitude: baseLat,
          areaCode: window.config.areaCode,
          limit: 50
        };
        
        // 距离筛选（转换为米）
        if (this.filterDistance) {
          params.distance = parseInt(this.filterDistance) * 1000;
        }
        
        // 网点类型筛选
        if (this.filterType) {
          params.siteType = this.filterType;
        }
        
        const res = await getNearbyList(params);
        if (res.data && res.data.success && res.data.obj) {
          let siteData = res.data.obj || [];
          
          // 映射接口字段
          let mappedSites = siteData.map(site => ({
            id: site.id || site.siteCode,
            siteName: site.siteName,
            address: site.address,
            lng: site.lng,
            lat: site.lat,
            time: site.time || '',
            phone: site.phone || '',
            areaLevel: String(site.areaLevel || '4'),
            traffic: site.traffic || '',
            areaCode: site.areaCode || '',
            centerguid: site.centerguid || '',
            distance: site.distance || this.calculateDistance(
              this.userLocation.lng || this.defLag,
              this.userLocation.lat || this.defLat,
              site.lng,
              site.lat
            )
          }));
          
          // 按区域筛选
          if (this.filterArea) {
            mappedSites = mappedSites.filter(site => {
              if (site.areaCode) {
                return site.areaCode.startsWith(this.filterArea);
              }
              const areaItem = this.areaOptions.find(o => o.value === this.filterArea);
              return areaItem && site.address && site.address.includes(areaItem.label);
            });
          }
          
          this.siteList = mappedSites;
        } else {
          this.siteList = [];
        }
      } catch (error) {
        console.error('获取附近网点失败:', error);
        // 接口失败，使用本地筛选
        const maxDistance = parseFloat(this.filterDistance);
        this.siteList = this.allSiteList.filter(site => parseFloat(site.distance) <= maxDistance);
      }
      
      this.updateMap();
    },
    // 更新地图显示
    updateMap() {
      setTimeout(() => {
        if (this.siteList.length > 0) {
          this.initMap();
        } else {
          if (this.mapObj) {
            this.mapObj.clearMap();
          }
          this.initMap();
          Toast.fail('暂无符合条件的站点');
        }
        this.showLoading = false;
      }, 300);
    },

    guideList() {
      this.$router.push('/guideList');
    },
    //跳转首页
    routerHome() {
      if (this.$router.currentRoute.path !== "/") {
        this.$router.replace('/');
      }
    },
    //跳转个人中心
    routerUser() {
      if (this.$router.currentRoute.path !== "/user") {
        this.$router.replace('/user');
      }
    },
    //消息中心
    routerMessage() {
      Toast('消息中心开发中');
    },
    //跳转反馈
    fkReply() {
      this.$router.push('/reply');
    },
    //跳转云上综窗
    goClund() {
      window.location.href = 'https://yszc.sc.yichang.gov.cn/robot/index.html#/';
    },
  },
  beforeDestroy() {
    if (this.mapObj) {
      this.mapObj.destroy();
      this.mapObj = null;
    }
  },
  activated() {
    // 从其他页面返回时，重新隐藏地图控件
    if (this.mapObj) {
      this.$nextTick(() => {
        this.hideMapControls();
      });
    }
  },
  async mounted() {
    var winHeight = $(window).height(); //获取当前页面高度
    $("body").height(winHeight);//监听手机端键盘顶起影响页面布局
  }

}
</script>


<style lang="scss" scoped>
@import '../assets/style/map.scss';
</style>

<style lang="scss">
/* 底部导航（与首页一致） */
.map-reserve .bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(60px + constant(safe-area-inset-bottom));
  height: calc(60px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background: #fff;
  display: flex;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);

  .nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .van-icon {
      margin-bottom: 4px;
      color: #999;
    }

    span {
      font-size: 11px;
      color: #999;
    }

    &.active {
      .van-icon { color: #5892FB; }
      span { color: #5892FB; }
    }
  }
}
</style>